import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import { Box, Icon, Image } from "@chakra-ui/react";
import { FiPlayCircle } from "react-icons/fi";
const VideoThumbnail = ({ src, onClick, autoPlay = false, }) => {
    const [imgError, setImgError] = useState(false);
    const [videoLoaded, setVideoLoaded] = useState(false);
    const videoRef = useRef(null);
    const baseUrl = src.split("?")[0];
    const isVideo = /(0?mp4|0?mov|0?webm|\.mp4|\.mov|\.webm)$/i.test(baseUrl);
    const guessedThumb = baseUrl.replace(/(0?mp4|0?mov|0?webm|\.mp4|\.mov|\.webm)$/i, ".jpg");
    // Auto-play video when autoPlay prop is true
    useEffect(() => {
        if (autoPlay && isVideo && videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.error("Video autoplay failed:", error);
            });
        }
    }, [autoPlay, isVideo]);
    if (imgError && !videoLoaded) {
        return (_jsxs(Box, { role: "button", onClick: onClick, w: "100%", h: "100%", display: "flex", alignItems: "center", justifyContent: "center", bg: "linear-gradient(180deg, #111 0%, #222 100%)", position: "relative", children: [isVideo && (_jsx("video", { src: src, style: { display: "none" }, onLoadedData: (e) => {
                        const video = e.currentTarget;
                        const canvas = document.createElement("canvas");
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        const ctx = canvas.getContext("2d");
                        if (ctx) {
                            ctx.drawImage(video, 0, 0);
                            setVideoLoaded(true);
                        }
                    } })), _jsx(Icon, { as: FiPlayCircle, boxSize: "36px", color: "white" })] }));
    }
    // If autoPlay is enabled and it's a video, render video element
    if (autoPlay && isVideo) {
        return (_jsxs(Box, { position: "relative", w: "100%", h: "100%", onClick: (e) => {
                e.stopPropagation();
                onClick();
            }, cursor: "pointer", overflow: "hidden", children: [_jsx(Box, { as: "video", ref: videoRef, src: src, objectFit: "cover", w: "100%", h: "100%", muted: true, playsInline: true, loop: true, autoPlay: true, style: { display: "block" } }), _jsx(Box, { position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", bg: "rgba(0,0,0,0.1)", pointerEvents: "none", opacity: 0, transition: "opacity 0.3s ease", _hover: { opacity: 1 }, children: _jsx(Icon, { as: FiPlayCircle, color: "white", boxSize: "28px" }) })] }));
    }
    return (_jsxs(Box, { position: "relative", w: "100%", h: "100%", onClick: (e) => {
            e.stopPropagation();
            onClick();
        }, cursor: "pointer", children: [_jsx(Image, { src: isVideo ? guessedThumb : src, alt: "media-thumbnail", objectFit: "cover", w: "100%", h: "100%", draggable: false, transition: "transform 0.25s ease", _hover: { transform: "scale(1.03)" }, onError: () => setImgError(true), fallback: _jsx(Box, { w: "100%", h: "100%", display: "flex", alignItems: "center", justifyContent: "center", bg: "linear-gradient(180deg, #111 0%, #222 100%)", children: _jsx(Icon, { as: FiPlayCircle, boxSize: "36px", color: "white" }) }) }), isVideo && (_jsx(Box, { position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", bg: "rgba(0,0,0,0.3)", pointerEvents: "none", children: _jsx(Icon, { as: FiPlayCircle, color: "white", boxSize: "28px" }) }))] }));
};
export default VideoThumbnail;
